import AnalyticsIcon from '@material-ui/icons/TrendingUp'
import Utilization from './Utilization';

export default {
  home: Utilization,
  icon: AnalyticsIcon,
}
